import styled from 'styled-components';

export default styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
`;
